import { TableSplit } from '@carbon/icons-react';
import * as React from 'react';
import { OutlinedIcon } from 'vet-bones/design-system/components';

import { DataSourceIcon } from 'src/components/resourceDialog/DataSourceIcon';
import { getDataSourceIcon } from 'src/templates/icons';

import sidebarStyles from 'src/containers/ProjectSidebar/projectSidebar.module.scss';

type VirtualGraphIconProps = {
  dataSourceType: string | null | undefined;
  stardogVersion?: string;
};

export const VirtualGraphIcon: React.VFC<VirtualGraphIconProps> = ({
  dataSourceType,
  stardogVersion,
}) => {
  if (!dataSourceType) {
    return <OutlinedIcon IconComponent={TableSplit} />;
  }

  const dataSourceIcon = getDataSourceIcon({
    dataSourceType,
    stardogVersion,
  });

  return (
    <OutlinedIcon
      elevated={dataSourceIcon.isBlueprintIcon}
      iconClassName={
        dataSourceIcon.isBlueprintIcon
          ? undefined
          : sidebarStyles.virtualGraphIconImage
      }
      IconComponent={() => (
        <DataSourceIcon
          dataSourceType={dataSourceType}
          size={16}
          stardogVersion={stardogVersion}
        />
      )}
    />
  );
};
